import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

export const totalUsersCountColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'totalUsers',
  acessorKey: 'totalUsers',
  label: <Trans i18nKey="total_users" />,
  sortable: false,
  ...options,
});
